export default __webpack_public_path__ + "static/media/genealogyBanner.8c5f211d.jpg";